import {
  PROBATION_FETCHING,
  PROBATION_FAILED,
  PROBATION_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PROBATION_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case PROBATION_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case PROBATION_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
